import { render, staticRenderFns } from "./CorporationAssignUser.vue?vue&type=template&id=f944007a&"
import script from "./CorporationAssignUser.vue?vue&type=script&lang=js&"
export * from "./CorporationAssignUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports